
import { Vue, Component, Prop } from 'vue-property-decorator';
import SwitchBase from '@/ui/components/devices/devices/base/SwitchBase.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import { IDevice } from '@/types/devices.types';

/**
 * Component that represent VentilatorSwitch device
 */
@Component({
  components: {
    SwitchBase,
    DeviceLayout,
  },
})
export default class VentilatorSwitch extends Vue {
  @Prop() deviceData!: IDevice;
}
